"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerrorAbilityHandler = exports.TerrorActorAbilityFactory = exports.TerrorAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class TerrorAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Terror;
        this.__typeName = "Terror";
    }
}
exports.TerrorAbilityArgs = TerrorAbilityArgs;
let TerrorActorAbilityFactory = class TerrorActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Terror", "OneEnemies", 3);
    }
};
TerrorActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Terror")
], TerrorActorAbilityFactory);
exports.TerrorActorAbilityFactory = TerrorActorAbilityFactory;
let TerrorAbilityHandler = class TerrorAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Death", 70)
            ],
            onHit(sequence) {
                sequence.push(new __1.InstantVfxStepArgs(new __1.ActorVfxLocationSelector(selectedEnemy, "feet"), "EngulfingDarkness"));
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new __1.StunEffectArgs(),
                    duration: Duration_1.Duration.Turns(1),
                    sequence
                });
            }
        });
    }
};
TerrorAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Terror)
], TerrorAbilityHandler);
exports.TerrorAbilityHandler = TerrorAbilityHandler;
